import { render, staticRenderFns } from "./SmartCampaign.vue?vue&type=template&id=5192d316&scoped=true"
import script from "./SmartCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./SmartCampaign.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SmartCampaign.vue?vue&type=style&index=0&id=5192d316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5192d316",
  null
  
)

export default component.exports